import React, { useContext } from 'react'

// Libs
import { Tooltip } from '@mui/material'

// Components
import { IconSwitch } from '../../../../../components/icons/IconSwitch'

// Helpers
import useToasterHelper from '../../../../../helpers/ToasterHelper'

// Models
import { IHorseData } from '../../../../../models/horse/horse.interface'
import { IRider } from '../../../../../types/entryRider'

// Constants
import { PAYMENT_STATUS, PAYMENT_TYPE } from '../../../../../types/payment'
import { MESSAGES_CONST } from '../../../../../const/messages-const'
import { MODAL_CONSTS } from '../../../../../const/modal-const'
import { HandleModalContext } from '../../../../../layout/mainlayout/MainLayout'
import { cloneDeep } from 'lodash'

interface ButtonSwitchHorseProps {
  row: IRider
  filteredRiders: IRider[]
  setFilteredRiders: (riders: IRider[]) => void
}

export const ButtonSwitchHorse: React.FC<ButtonSwitchHorseProps> = ({
  row,
  filteredRiders,
  setFilteredRiders,
}) => {
  const toastFunction = useToasterHelper()
  const handleModalContext = useContext(HandleModalContext)

  return (
    <Tooltip title={<span className={'text-[12px]'}>Switch horse</span>} placement="top" arrow>
      <button
        className={'group'}
        onClick={() => {
          if (
            (row.paymentType === PAYMENT_TYPE.DEFAULT &&
              row.paymentStatus === PAYMENT_TYPE.DEFAULT) ||
            row.paymentStatus === PAYMENT_STATUS.PENDING
          ) {
            return toastFunction.info({ message: MESSAGES_CONST.NOT_REGISTERED_YET })
          }

          handleModalContext?.handleModal(true, MODAL_CONSTS.SWITCH_HORSE, {
            rider: row,
            cb: (horse: IHorseData, horseIds: string[]) => {
              const filteredRiders_ = cloneDeep(filteredRiders)
              const filteredRidersIndex = filteredRiders_.findIndex((r) => r.id === row?.id)

              if (!filteredRiders_[filteredRidersIndex]) return null

              filteredRiders_[filteredRidersIndex].horseProfilePicture = horse.horseProfilePicture
              filteredRiders_[filteredRidersIndex].horseName = horse.horseName
              filteredRiders_[filteredRidersIndex].horseIds = horseIds
              filteredRiders_[filteredRidersIndex].horseId = horse.horseId || ''

              setFilteredRiders([...filteredRiders_])

              handleModalContext?.handleModal(false, MODAL_CONSTS.SWITCH_HORSE)
            },
          })
        }}
      >
        <IconSwitch />
      </button>
    </Tooltip>
  )
}
